function feature() {
    return (
      <main>
         <section className="feature">
           <div className='container'>
              <div className='row'>
                <div class="col-12 col-lg-6">
                  <h2 className="feature-header">Effortless Markdown Composition.</h2>
                  <p className="pt-3">Breeze through creating Markdown documents as easily as typing a text message. Our intuitive input box offers ample space for your thoughts to unfold.</p>
                  <p>As soon as you type, the preview box mirrors your input, transforming it into beautiful HTML. Formatting issues vanish - they’re caught before they can cause trouble.</p>
                  <p>With MarkdownMagic, you can focus on what really matters - your ideas.</p>
                </div>
              </div>
           </div>
         </section>
       </main>
    );
  }
  
  export default feature;
  